<div>
  <div class="db-content">
    <h1 class="mb8">Create your website<br> with the power of AI</h1>
    <p class="mb20">Answer a few questions and our AI will generate<br/>
      a personalized website with tailored content and images.</p>
    <div class="ds-notification-gray with-radius" *ngIf="showThemeNotification">
      <div>
        <i class="db-icon db-icon-ds-info-bg" [ngClass]="{'yellow': !themeIsActive}"></i>
        <div>
          <p *ngIf="!themeIsActive">
            Website generation with AI requires the 10Web Builder<br/>
            theme. <a class='db-link-black black' (click)="activateTheme.emit()">Install and activate</a> it to access this feature.</p>
          <p *ngIf="!!themeIsActive">The new AI generated page will become your site’s<br> homepage. Your existing pages won’t be affected.</p>
        </div>
      </div>
    </div>
    <div class="db-actions-buttons mt50" [ngClass]="{'space-between': !!isOnboarding}">
      <button class="ds-btn-black rectangle"  [ngClass]="{'ds-btn-disabled': loading || (showThemeNotification && !themeIsActive)}" (click)="start.emit()">
        <span *ngIf="!loading" [innerHTML]="'Generate with AI' | lowerCaseSpecificWords"></span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </div>
  <div class="db-insert-url mt20" *ngIf="!!themeIsActive">
    <p>Or <b (click)="createPageDialog()">insert the URL</b> of any desired page, and we will recreate<br/> the layout and design elements.</p>
  </div>
</div>
<div class="create-ai-image-wrap">
  <div class="create-ai-image">
    <img src="assets/images/ai/onboarding/ai-informative-light-full.svg" alt="">
  </div>
</div>
